






















import Vue, { PropType } from 'vue';

import { Packet } from '@/models/packet';
import * as Utils from '@/utils';

import Icon from '@/components/Icon.vue';
import LazyRenderingList from '@/components/LazyRenderingList.vue';
import PacketCard from '@/components/PacketCard.vue';

export default Vue.extend({
  components: {
    Icon,
    LazyRenderingList,
    PacketCard
  },

  props: {
    filter: String,
    packets: Array as PropType<Packet[]>,
    createEnabled: Boolean
  },

  computed: {
    filtered(): Packet[] {
      if (!this.filter) {
        return this.packets;
      }

      return Utils.findTerm(this.filter, this.packets, p => [
        p.name,
        p.description,
        ...p.objectives.map(o => o.name),
        ...p.outcomes.map(o => o.value)
      ]);
    }
  },

  watch: {
    filtered(current, prev) {
      if (current.length != prev.length) {
        this.$emit('filter', { count: current.length });
      }
    }
  }
});
